import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.array.join';
import 'core-js/modules/es.array.map';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.keys';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.string.repeat';
import 'core-js/modules/es.string.split';
import { isWorldReadyInstance } from '@paypalcorp/worldready-core';
import { DisplayNames } from '@paypalcorp/worldready-display-names';
import { assert, assertType } from 'yaassertion';
import 'globalize/dist/globalize/number';
import 'globalize/dist/globalize/date';

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

var _excluded = ["style"];
var getMissingMetadataError = function getMissingMetadataError(path) {
  var message = "Missing WorldReady metadata, please refer to https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data.html";
  if (path) {
    message += "\nPath: " + path;
  }
  return new Error(message);
};
function globalizeToWorldReadyError(error) {
  if (error.code === "E_MISSING_CLDR") {
    return getMissingMetadataError(error.stack);
  }
  return new Error(["Oops, internal error", error.message, error.stack].join("\n"));
}
function getWorldReadyDateError(error, options) {
  if (options === void 0) {
    options = {};
  }
  var WORLDREADY_DATE_ERROR_CODES = {
    E_INVALID_OPTIONS: "E_INVALID_OPTIONS",
    E_MISSING_IANA_TZ: "E_MISSING_IANA_TZ"
  };
  if (error.code === WORLDREADY_DATE_ERROR_CODES.E_INVALID_OPTIONS) {
    throw new RangeError("Invalid `options.style`: `" + JSON.stringify(error.value) + "`.");
  } else if (error.code === WORLDREADY_DATE_ERROR_CODES.E_MISSING_IANA_TZ) {
    throw new Error("Missing required timezone metadata. Make sure that you are exporting metadata for \"" + options.timeZone + "\" using WorldReady.export API.");
  }
  throw globalizeToWorldReadyError(error);
}
function validateCldr(path, value, options) {
  if (options === void 0) {
    options = {
      skip: []
    };
  }
  var skipBoolean = options.skip.some(function (regex) {
    return regex.test(path);
  });
  if (skipBoolean) {
    return;
  }
  if (value === undefined) {
    throw getMissingMetadataError(path);
  }
}
var DATE_STYLES = {
  DATE_SHORT: "date-short",
  BANK_CARD_EXPIRY: "bank-card-expiry",
  TIMEZONE_SHORT: "timezone-short",
  TIMEZONE_MEDIUM: "timezone-medium",
  TIMEZONE_LONG: "timezone-long"
};
var BANK_CARD_EXPIRY_FORMAT = "MM/YY";

/**
 * DateInputMaskFormat(worldReady, options)
 */
var DateInputMaskFormat = /*#__PURE__*/function () {
  function DateInputMaskFormat(worldReady, options) {
    if (options === void 0) {
      options = {};
    }
    // Error checking
    if (process.env.NODE_ENV !== "production") {
      assert(isWorldReadyInstance(worldReady), "WorldReady object missing.");
      assertType(options, "options", ["plain object"]);
      assertType(options.style, "options.style", ["string", "undefined"]);
    }
    var dateOptions = globalizeDateOptions(options);
    var cldr = worldReady.globalize.cldr;
    var cldrData = Object.assign({}, cldr.main("dates/fields"));
    if (!Object.keys(cldrData).length) {
      validateCldr();
    }
    var partsArray = [];
    try {
      var dummyDate = new Date(2014, 2, 2);
      partsArray = worldReady.globalize.formatDateToParts(dummyDate, dateOptions);
    } catch (error) {
      throw getWorldReadyDateError(error);
    }
    var maskChars = new DisplayNames(worldReady, {
      type: "dateTimeField",
      style: "abbreviated"
    }).select(["day", "month", "year"]);
    this.maskArray = generateMaskArray(partsArray, cldrData, maskChars);
  }
  var _proto = DateInputMaskFormat.prototype;
  _proto.format = function format() {
    var maskArray = this.formatToParts();
    return maskArray.map(function (partObj) {
      return partObj.value;
    }).join("");
  };
  _proto.formatToParts = function formatToParts() {
    return this.maskArray;
  };
  return DateInputMaskFormat;
}();
function globalizeDateOptions(options) {
  var aux;
  var globalizeDateOptions = {};

  // Set Defaults
  var _options$style = options.style,
    style = _options$style === void 0 ? DATE_STYLES.DATE_SHORT : _options$style,
    otherProps = _objectWithoutPropertiesLoose(options, _excluded);
  var optionsWithDefaults = Object.assign({
    style: style
  }, otherProps);

  // {raw: "MM/YY"}
  if (optionsWithDefaults.style === DATE_STYLES.BANK_CARD_EXPIRY) {
    globalizeDateOptions["raw"] = BANK_CARD_EXPIRY_FORMAT;
    globalizeDateOptions.timeZone = optionsWithDefaults.timeZone;
    return globalizeDateOptions;
  }
  if (optionsWithDefaults.style.includes("-")) {
    aux = optionsWithDefaults.style.split("-");
    globalizeDateOptions[aux[0]] = aux[1];
  } else {
    globalizeDateOptions.skeleton = optionsWithDefaults.style;
  }
  return globalizeDateOptions;
}
function generateMaskArray(partsArray, cldrData, maskChars) {
  var datePartMasks = generateDatePartMasks(cldrData, maskChars);
  return partsArray.map(function (partObj) {
    var type = partObj.type,
      value = partObj.value;

    // preserve literals like `/`
    if (type === "literal") {
      return partObj;
    }
    // if formatted value is not a number (e.g. MMM -> 'Feb'), cannot create mask for it
    if (isNaN(parseInt(value, 10))) {
      throw new Error("Cannot create mask: " + type + " field is not numeric.");
    }
    // load masks for this type ('year', 'month', 'date') based on length of formatted dummy value
    var partMask = datePartMasks[type] && datePartMasks[type][value.length];
    if (!partMask) {
      // throw an error if there's no mask for this type (e.g. 'weekday', 'era', etc.)
      throw new Error("Cannot create mask: " + type + " field has no appropriate mask.");
    }
    return {
      type: type,
      value: partMask
    };
  });
}
function generateDatePartMasks(cldrData, maskChars) {
  var noExpansion = cldrData["day-abbreviated"] && cldrData["day-abbreviated"].noExpansion ? cldrData["day-abbreviated"].noExpansion : false;
  var dayMaskChar = maskChars[0],
    monthMaskChar = maskChars[1],
    yearMaskChar = maskChars[2];
  var datePartMasks = noExpansion ? {
    // masks to use if language doesn't use expansion

    year: [null, yearMaskChar, yearMaskChar, yearMaskChar, yearMaskChar],
    month: [null, monthMaskChar, monthMaskChar],
    day: [null, dayMaskChar, dayMaskChar]
  } : {
    // masks to use if language uses expansion

    // expand all y's except yy to 4 characters
    year: [null, yearMaskChar.repeat(4), yearMaskChar.repeat(2),
    // yy --> 2 chars
    yearMaskChar.repeat(4), yearMaskChar.repeat(4)],
    // expand all M's to 2 characters
    month: [null, monthMaskChar.repeat(2), monthMaskChar.repeat(2)],
    // expand all d's to 2 characters
    day: [null, dayMaskChar.repeat(2), dayMaskChar.repeat(2)]
  };
  return datePartMasks;
}

export { DateInputMaskFormat };
